import styled from "styled-components";

const loadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => props.height};
`;

export default {
  loadingContainer,
};
